import type {
  CreateOrderPayload,
  GetOrdersPayload,
  RespondToOrderPayload,
} from "../../../interfaces/OrderObject";

/**
 * Build the create-order request body. Delivery fields are included only for
 * DELIVERY orders; ON_PREMISE orders omit address/pin entirely.
 * `buyerPhone` is always sent (ordering is signed-in only).
 * `totalPrice` is sent as a temporary workaround until the backend computes it.
 */
export function buildCreateOrderPayload(payload: CreateOrderPayload): Record<string, unknown> {
  const body: Record<string, unknown> = {
    businessId: payload.businessId,
    collectionUrl: payload.collectionUrl,
    totalPrice: payload.totalPrice,
    fulfillmentType: payload.fulfillmentType,
    buyerPhone: payload.buyerPhone,
  };
  if (payload.fulfillmentType === "DELIVERY") {
    if (payload.deliveryAddress !== undefined) body.deliveryAddress = payload.deliveryAddress;
    if (payload.deliveryPin !== undefined) body.deliveryPin = payload.deliveryPin;
  }
  return body;
}

export function buildRespondToOrderPayload(
  payload: RespondToOrderPayload
): Record<string, unknown> {
  return {
    orderId: payload.orderId,
    status: payload.status,
  };
}

/**
 * Build the get-orders body. `historyRequired` is sent only when true (default =
 * today only). A date range reaches past today, so it implies history here —
 * callers just pass what the user picked.
 */
export function buildGetOrdersPayload(payload: GetOrdersPayload): Record<string, unknown> {
  const body: Record<string, unknown> = {
    businessId: payload.businessId,
  };
  if (payload.historyRequired || payload.fromDate || payload.toDate) body.historyRequired = true;
  if (payload.fromDate) body.fromDate = payload.fromDate;
  if (payload.toDate) body.toDate = payload.toDate;
  return body;
}
